import { httpCall, httpFetch } from "../../../common/util";
import ActivityCreationActionApiMapping from "./actionURLMapping";

export const fetchCreateActivityData = (ActionType, payload) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload,
        url: ActivityCreationActionApiMapping[ActionType].url
    });
};
export const fetchSkillsetTags = (ActionType) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        }, 
        url: ActivityCreationActionApiMapping[ActionType].url
    });  
};

export const fetchAssignmentMethodTeamMemberList = (ActionType) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        }, 
        url: ActivityCreationActionApiMapping[ActionType].url
    });  
};

export const fetchAssignmentMethodB2BList = (ActionType) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        }, 
        url: ActivityCreationActionApiMapping[ActionType].url
    });  
};

export const fetchAssignmentMethodContractList = (ActionType,payload) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        }, 
        params: payload, 
        url: ActivityCreationActionApiMapping[ActionType].url
    });  
};

export const getLocationByZip = (ActionType,payload) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload, 
        url: ActivityCreationActionApiMapping[ActionType].url
    });  
};

export const createActivity = (ActionType, payload) => {
    return httpFetch({
        url: ActivityCreationActionApiMapping[ActionType].url,
        method: ActivityCreationActionApiMapping[ActionType].method,
        credentials: "include",
        data: payload
    })
};

export const updateActivity = (ActionType, payload) => {
    return httpFetch({
        url: ActivityCreationActionApiMapping[ActionType].url,
        method: ActivityCreationActionApiMapping[ActionType].method,
        credentials: "include",
        data: payload
    })
};

export const fetchEditActivityData = (ActionType, payload) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload, 
        url: ActivityCreationActionApiMapping[ActionType].url
    });  
};

export const fetchCloneActivityData = (ActionType, payload) => {
    return httpCall({
        method: ActivityCreationActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload, 
        url: ActivityCreationActionApiMapping[ActionType].url
    });  
};